import { render, staticRenderFns } from "./chainDetail.vue?vue&type=template&id=29dbc1d2&scoped=true&"
import script from "./chainDetail.vue?vue&type=script&lang=js&"
export * from "./chainDetail.vue?vue&type=script&lang=js&"
import style0 from "./chainDetail.vue?vue&type=style&index=0&id=29dbc1d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dbc1d2",
  null
  
)

export default component.exports